/* ユーザ一覧リスト */
import React, { useState, memo } from 'react';
import { Grid, _ } from 'gridjs-react';
var UserList = function (_a) {
    var users = _a.users, options = _a.options, t = _a.t;
    var rows = useState(10)[0];
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { data: users, columns: [
                {
                    id: 'user_name',
                    name: t('ユーザ名'),
                    width: '200px',
                },
                {
                    id: 'email',
                    name: t('職員番号'),
                    width: '80px',
                },
                {
                    id: 'group',
                    name: t('所属部署'),
                    width: '80px',
                    formatter: function (cell) {
                        var _a;
                        return _(React.createElement(React.Fragment, null, (_a = options === null || options === void 0 ? void 0 : options.office.find(function (office) { return office.key === cell; })) === null || _a === void 0 ? void 0 : _a.value));
                    },
                },
                {
                    id: 'created_at',
                    name: t('登録日'),
                    width: '100px',
                },
                {
                    id: 'role',
                    name: t('権限'),
                    width: '80px',
                },
                {
                    id: 'detail',
                    name: t('詳細'),
                    width: '80px',
                    formatter: function (cell) {
                        return _(React.createElement("a", { className: "btn btn-main-color", href: "" + location.origin + process.env.MIX_MOCK_URL + "/staff/maintenance/user/detail/" + cell }, t('詳細')));
                    },
                },
            ], search: false, sort: true, pagination: {
                enabled: true,
                limit: rows,
            }, fixedHeader: true, height: "600px" })));
};
export default memo(UserList);
